import { useEffect, useRef, useState } from 'react'

/**
 * Diálogo de borrado con confirmación escrita.
 *
 * `window.confirm` no vale para esto: no permite explicar el alcance —que borrar una función la
 * quita también del repositorio, por ejemplo— y basta un Intro distraído para perder algo. Aquí
 * hay que teclear el nombre, que es el mismo listón que ya pone la baja de un proyecto.
 *
 * Se usa <dialog> nativo: trae la captura de foco, el cierre con Escape y el fondo modal sin
 * tener que reimplementarlos, que es donde estos diálogos suelen quedarse a medias.
 */
export function ConfirmarBorrado({ abierto, nombre, titulo, children, etiquetaBoton = 'Borrar', onCancelar, onConfirmar, ocupado }) {
  const ref = useRef(null)
  const [escrito, setEscrito] = useState('')

  useEffect(() => {
    const d = ref.current
    if (!d) return
    if (abierto && !d.open) { setEscrito(''); d.showModal() }
    if (!abierto && d.open) d.close()
  }, [abierto])

  const coincide = escrito === nombre

  return (
    <dialog ref={ref} className="dialogo" onCancel={(e) => { e.preventDefault(); onCancelar?.() }}>
      <form method="dialog" onSubmit={(e) => { e.preventDefault(); if (coincide && !ocupado) onConfirmar?.() }}>
        <h2 className="h2" style={{ marginTop: 0 }}>{titulo}</h2>
        <div style={{ color: 'var(--fg-2)', fontSize: 13, lineHeight: 1.55 }}>{children}</div>

        <label className="field-label" htmlFor="conf-borrado" style={{ marginTop: 16 }}>
          Escribe <span className="mono">{nombre}</span> para confirmar
        </label>
        <input id="conf-borrado" className="input wide" autoFocus value={escrito}
               placeholder={nombre} autoComplete="off" spellCheck="false"
               onChange={(e) => setEscrito(e.target.value)} />

        <div className="toolbar" style={{ marginTop: 18, justifyContent: 'flex-end' }}>
          <button type="button" className="btn secondary" onClick={onCancelar} disabled={ocupado}>
            Cancelar
          </button>
          <button className="btn danger" disabled={!coincide || ocupado}>
            {ocupado ? 'Borrando…' : etiquetaBoton}
          </button>
        </div>
      </form>
    </dialog>
  )
}
